import { UnitBM } from '../types/BusinessModel/UnitBM';
import { Unit } from '../types/ViewModel/Unit';

export const createUnit = (unit: UnitBM): Unit => {
    return {
        unitId: unit.unitId,
        unitName: unit?.name,
    };
};

export const createUnitList = (units: UnitBM[]) => units.map((unit) => createUnit(unit));
